(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .directive('questionAttachment', directive);

    function directive() {
        return {
            // scope: {
            //     campaign: '=',
            //     questionId: '@',
            //     attachmentPrompt: '@',
            //     attachmentComponents: '=',
            //     savedAttachments: '=',
            //     filesAttached: '&'
            // },
            // templateUrl: 'js/campaign/questionAttachment.tpl.html',
            // controller: ['$scope', '$timeout', 'campaignService',
            //     function ($scope, $timeout, campaignService) {
            //         var form,
            //             validity = true;
            //         $scope.upload = {
            //             _uploading: {},
            //             _uploaded: {},
            //             _inError: {},
            //             _fileDownloading: {},
            //             _errorIndex: 0
            //         };
            //
            //         $scope.attachmentComponents.some(function (comp) {
            //             if (comp.IsRequired) {
            //                 validity = false;
            //                 return true;
            //             }
            //             return false;
            //         });
            //
            //         if ($scope.savedAttachments && $scope.savedAttachments.length > 0) {
            //             $scope.savedAttachments.forEach(function (attachment) {
            //                 $scope.upload._uploaded[attachment.QuesCompAttachID] = $scope.upload._uploaded[attachment.QuesCompAttachID] || [];
            //                 $scope.upload._uploaded[attachment.QuesCompAttachID].push({
            //                     fileName: attachment.FileName,
            //                     label: attachment.Label,
            //                     compAttachmentId: attachment.QuestCompAttachID,
            //                     blobID: attachment.BlobID
            //                 });
            //             })
            //         }
            //
            //         $scope.fileUploadChanged = function (compAttachmentId, label, files) {
            //             // List file names with loading
            //             $scope.upload._uploading[compAttachmentId] = $scope.upload._uploading[compAttachmentId] || [];
            //             if (_.isArray(files)) {
            //                 files.forEach(function (file) {
            //                     $scope.upload._uploading[compAttachmentId].push(file);
            //                 });
            //             }
            //
            //             // Clear Field
            //             $scope.upload[label] = [];
            //
            //             // Upload Files
            //             $scope.filesAttached({compAttachmentId: compAttachmentId, label: label, files: files, errorCb: uploadError.bind(this, $scope)})
            //                 .then(function (uploaded) {
            //                     // console.log(uploaded, $scope.upload._uploading)
            //                     if (uploaded !== null) {
            //                         $scope.upload._uploaded[compAttachmentId] = $scope.upload._uploaded[compAttachmentId] || [];
            //                         uploaded.forEach(function (savedFile) {
            //                             $scope.upload._uploading[compAttachmentId].some(function (tempFile, idx) {
            //                                 if (tempFile.name === savedFile.fileName) {
            //                                     $scope.upload._uploading[compAttachmentId].splice(idx, 1);
            //                                     $scope.upload._uploaded[compAttachmentId].push(savedFile)
            //                                     return true;
            //                                 }
            //                                 return false;
            //                             })
            //                         });
            //                     }
            //                 });
            //         };
            //
            //         $scope.downloadAttachment = function (compAttachmentId, blobId) {
            //             $scope.upload._fileDownloading[compAttachmentId] = null;
            //             $timeout(function() {
            //                 $scope.upload._fileDownloading[compAttachmentId] = campaignService.getDownloadAttachmentUrl($scope.campaign.subURL, blobId);
            //             }, 0)
            //         };
            //
            //         function uploadError(scope, error, compAttachmentId, label, files) {
            //             scope.upload._inError[compAttachmentId] = scope.upload._inError[compAttachmentId] || [];
            //             files.forEach(function (file) {
            //                 scope.upload._uploading[compAttachmentId].some(function (uploading, idx) {
            //                     if (uploading.name === file.name) {
            //                         scope.upload._inError[compAttachmentId].push({
            //                             name: file.name,
            //                             error: error.message,
            //                             index: scope.upload._errorIndex
            //                         });
            //                         planToRemoveErrorFile(scope, compAttachmentId, scope.upload._errorIndex);
            //                         scope.upload._uploading[compAttachmentId].splice(idx, 1);
            //                         ++scope.upload._errorIndex;
            //                         return true;
            //                     }
            //                     return false;
            //                 })
            //             })
            //         }
            //
            //         function planToRemoveErrorFile(scope, compAttachmentId, index) {
            //             var idx = _.clone(index);
            //
            //             $timeout(function () {
            //                 var i = _.findIndex(scope.upload._inError[compAttachmentId], {'index': idx});
            //                 if (i > -1) {
            //                     scope.upload._inError[compAttachmentId].splice(i, 1);
            //                 }
            //             }, 5000);
            //         }
            //
            //         $timeout(function () {
            //             form = $scope['attForm' + $scope.questionId];
            //             form.$setValidity(validity);
            //         },0);
            //     }]
        }
    }
})();